import React, { useCallback, useMemo } from 'react';

import { SvgIconUrl } from 'common/components';

import { capitalizeFirstLetter } from 'utils/capitalizeFirstLetter';

import { PayentethodProps } from './types';

export const DepositMethod: React.FC<React.PropsWithChildren<PayentethodProps>> = React.memo(
  ({ onClick, ...method }) => {
    const { label, icon, image, id, hidden } = useMemo(() => method, [method]);

    const handleClick = useCallback(
      (event: React.MouseEvent<HTMLLIElement, MouseEvent>) => onClick(event, method),
      [method, onClick],
    );

    if (hidden) return null;

    return (
      <li id={id} data-test={id} className='deposit-list__item' onClick={handleClick}>
        {icon && <SvgIconUrl className='deposit__icon' symbol={icon} />}
        {image && <img src={image} className='deposit__icon' alt={label} loading='lazy' />}
        <span className='deposit__label'>{capitalizeFirstLetter(label)}</span>
      </li>
    );
  },
);

export const DepositMethodSkeleton = React.memo(() => (
  <li>
    <div className='deposit-list__item'>
      <SvgIconUrl className='deposit__icon deposit-list__item-skeleton deposit-list__item-skeleton--circle' />
      <span className='deposit__label deposit-list__item-skeleton'>Loading</span>
    </div>
  </li>
));
